export const AT_SET_CURRENT_NOT_FILLED_CARD_ID = 'NOT_FILLED_CARDS_CURRENT_NOT_FILLED_CARD_ID_SET';
